import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './componenetStyle/Uzytkownicy.css';
import { useAuth } from '../auth/AuthContext';

const API = process.env.REACT_APP_API_URL;

export default function Uzytkownicy() {
  const { hasPermission } = useAuth();
  const canManageUsers = hasPermission('users_manage');
  const [users, setUsers] = useState([]);
  const [login, setLogin] = useState('');
  const [haslo, setHaslo] = useState('');
  const [pracownicy, setPracownicy] = useState([]);
  const [idPrac, setIdPrac] = useState('');
  const token = localStorage.getItem('token');

  // pobierz listę użytkowników
  const fetchUsers = async () => {
    const res = await axios.get(`${API}/uzytkownicy`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setUsers(res.data);
  };

  // pobierz dostępnych pracowników (ci bez konta)
  const fetchFreePracownicy = async () => {
    const res = await axios.get(`${API}/pracownicy/bez-uzytkownika`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setPracownicy(res.data);
  };

  useEffect(() => {
    fetchUsers();
    fetchFreePracownicy();
  }, []);

  // dodaj nowego użytkownika
  const handleAdd = async e => {
    e.preventDefault();
    if (!canManageUsers) return;
    await axios.post(`${API}/uzytkownicy`, {
      login, haslo, id_pracownika: idPrac
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setLogin(''); setHaslo(''); setIdPrac('');
    await fetchUsers();
    await fetchFreePracownicy();
  };

  // reset hasła
  const handleReset = async (id) => {
    if (!canManageUsers) return;
    if (!window.confirm('Na pewno resetować hasło?')) return;
    const res = await axios.put(`${API}/uzytkownicy/${id}/reset-haslo`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    alert(`Nowe hasło dla ${res.data.login}: ${res.data.temporaryPassword}`);
  };

  return (
    <div className="uzytkownicy-container">
      <h2>Użytkownicy</h2>

      {/* ——— formularz dodawania ——— */}
      {canManageUsers ? <form onSubmit={handleAdd} className="add-user-form">
        <h3>Dodaj nowego użytkownika</h3>
        <input
          placeholder="Login"
          value={login}
          onChange={e => setLogin(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Hasło"
          value={haslo}
          onChange={e => setHaslo(e.target.value)}
          required
        />
        <select
          value={idPrac}
          onChange={e => setIdPrac(e.target.value)}
          required
        >
          <option value="">— wybierz pracownika —</option>
          {pracownicy.map(p => (
            <option key={p.id_pracownika} value={p.id_pracownika}>
              {p.imie} {p.nazwisko} ({p.rola})
            </option>
          ))}
        </select>
        <button type="submit">Zarejestruj</button>
      </form> : null}

      {/* ——— tabela istniejących użytkowników ——— */}
      <table className="users-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Login</th>
            <th>Rola</th>
            <th>Imię i nazwisko</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id_uzytkownika}>
              <td>{u.id_uzytkownika}</td>
              <td>{u.login}</td>
              <td>{u.rola}</td>
              <td>{u.imie} {u.nazwisko}</td>
              <td>
                {canManageUsers ? <button onClick={() => handleReset(u.id_uzytkownika)}>
                  Reset hasła
                </button> : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
